const errors: any = {};
const WithoutPnrValidation = (values: any) => {
  if (values.phone == undefined || values.phone.length < 10) {
    errors.phone = "Enter Valid Phone Number";
  } else {
    errors.phone = "";
  }

  if (values.departureDate == undefined || values.departureDate.length == "") {
    errors.departureDate = "Please Enter Depature Date";
  } else {
    errors.departureDate = "";
  }

  if (values.destinationFrom == undefined || values.destinationFrom.length == "") {
    errors.destinationFrom = "Please Enter Destination";
  } else {
    errors.destinationFrom = "";
  }

  if (values.destinationTo == undefined || values.destinationTo.length == "") {
    errors.destinationTo = "Please Enter Origin";
  } else {
    errors.destinationTo = "";
  }

  return errors;
};
export default WithoutPnrValidation;
